export default "/wp-content/themes/onnit/script/cart/dist/onnitAlphaBrainUpsellBg-80ec1881.jpg";